export function getCombinedSettingsMessageCount(
  newMessagesCount = {},
  localSettingsKey
) {
  const generic = Number(newMessagesCount.settings) || 0;
  const local = localSettingsKey
    ? Number(newMessagesCount[localSettingsKey]) || 0
    : 0;
  return generic + local;
}
